export function classMerge(...args: (string | undefined)[]): string {
  return args.filter(x => x).join(' ');
}
